


export function imageTypeValidation(fileType) {
	try {

		const allowedTypes = [
			'image/png',
			'image/jpeg',
			'image/gif',
		];

		if(!fileType) {
			return false;
		}

		if(allowedTypes.indexOf(fileType) > -1) {
			return true;
		} else {
			return false;
		}

	} catch(e) {
		return false;
	}
}



export function videoTypeValidation(fileType) {
	try {

		const allowedTypes = [
			'video/mp4',
		];

		if(!fileType) {
			return false;
		}

		if(allowedTypes.indexOf(fileType) > -1) {
			return true;
		} else {
			return false;
		}

	} catch(e) {
		return false;
	}
}


export function csvTypeValidation(fileType) {
	try {

		const allowedTypes = [
			'text/csv',
			'application/vnd.ms-excel',
		];

		if(!fileType) {
			return false;
		}

		if(allowedTypes.indexOf(fileType) > -1) {
			return true;
		} else {
			return false;
		}

	} catch(e) {
		return false;
	}
}